import { withNavigationWatcher } from './common/contexts/navigation';
import { HomePage } from './pages/Home/home';
import { ScanPage } from './pages/Scan/scan';
import { DevicePage } from './pages/device_loader/device';

const routes = [
  {
    path: '/scan',
    component: ScanPage
  },
  {
    path: '/home',
    component: HomePage
  },
  {
    path: '/device/:uuid',
    component: DevicePage
  }
];

export default routes.map(route => {
  return {
    ...route,
    component: withNavigationWatcher(route.component)
  };
});
